import Immutable from 'immutable';
import {
  HOME_PATH,
  TRAFFIC_UNIT_PATH,
  CABIN_CREW_UNIT_PATH,
  CABIN_CREW_PATH,
  CABIN_CREW_BUS_ASSIGNMENT_PATH,
  CABIN_CREW_MOVEMENT_HISTORY_PATH,
  CABIN_CREW_FOR_SCHEDULING_PATH,
  CABIN_CREW_ACTIVITY_PATH,
  CABIN_CREW_TASK_SUMMARY_PATH,
  ACTIVITY_BY_CABIN_CREW_PATH,
} from '../../../config/paths';

const INITIAL_STATE = Immutable.Map({
  cards: [
    {
      id: 'cabin-crew',
      title: 'Servicio a Bordo',
      path: CABIN_CREW_PATH,
      icon: 'signing',
    },
    {
      id: 'cabin-crew-assignment',
      title: 'Asignación de Servicio a Bordo',
      path: CABIN_CREW_BUS_ASSIGNMENT_PATH,
      icon: 'certificate',
    },
    {
      id: 'cabin-crew-movement-history',
      title: 'Movimientos de Servicio a Bordo',
      path: CABIN_CREW_MOVEMENT_HISTORY_PATH,
      icon: 'history',
    },
    {
      id: 'cabin-crew-for-scheduling',
      title: 'Programación de Servicio a Bordo',
      path: CABIN_CREW_FOR_SCHEDULING_PATH,
      icon: 'calendar',
    },
    {
      id: 'cabin-crew-activity',
      title: 'Tareo de Servicio a Bordo',
      path: CABIN_CREW_ACTIVITY_PATH,
      icon: 'list-alt',
    },
    {
      id: 'activity-by-cabin-crew',
      title: 'Tareo por Servicio a Bordo',
      path: ACTIVITY_BY_CABIN_CREW_PATH,
      icon: 'list-ul',
    },
    {
      id: 'cabin-crew-task-summary',
      title: 'Resumen de Tareo Servicio a Bordo',
      path: CABIN_CREW_TASK_SUMMARY_PATH,
      icon: 'file-text',
    },
  ],
  breadcrumbs: [
    { text: 'Inicio', tag: 'a', href: HOME_PATH },
    { text: 'Gestión de Tráfico', tag: 'a', href: TRAFFIC_UNIT_PATH },
    { text: 'Gestión de Servicio a Bordo', tag: 'span', href: CABIN_CREW_UNIT_PATH },
  ],
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
